"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OSCSysex;

var _oscJs = _interopRequireDefault(require("osc-js"));

var _utilities = require("./utilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// parse osc to sysex
let indentity = {
  manufacturer_id1: 0x00,
  // 0
  manufacturer_id2: 0x01,
  // 1
  manufacturer_id3: 0x5F,
  // 95
  manufacturer_id4: 0x7A,
  // 122
  product: 0x27,
  // 39
  format: 0x01 // 1

};

function OSCSysex(device, path, values, curve) {
  let oscMsg, oscPacked, gainValue, thresholdMult, barGainValuesSet, avgLowValue, avgLowValuesSet, multValue, multValuesSet;

  if (path.includes('/uc/save')) {
    oscMsg = new _oscJs.default.Message(path, ...(0, _utilities.formatValues)(values), curve);
  } else if (path.includes('gain')) {
    gainValue = (0, _utilities.formatFloat)(values);
    oscMsg = new _oscJs.default.Message(path, ...(0, _utilities.formatValues)(gainValue));
  } else if (path.includes('thresholdMult')) {
    thresholdMult = (0, _utilities.formatFloat)(values);
    oscMsg = new _oscJs.default.Message(path, ...(0, _utilities.formatValues)(thresholdMult));
  } else if (path.includes('barGain')) {
    let gainItems = values.split(',');

    if (gainItems.length === 2) {
      // set
      gainValue = (0, _utilities.formatFloat)(gainItems[1]);
      barGainValuesSet = [gainItems[0], gainValue].join(',');
      oscMsg = new _oscJs.default.Message(path, ...(0, _utilities.formatValues)(barGainValuesSet));
    } else if (gainItems.length === 1) {
      // get: don't format
      oscMsg = new _oscJs.default.Message(path, ...(0, _utilities.formatValues)(values));
    }
  } else if (path.includes('barAvg')) {
    let avgItems = values.split(',');

    if (avgItems.length === 2) {
      // set
      avgLowValue = (0, _utilities.formatFloat)(avgItems[1]);
      avgLowValuesSet = [avgItems[0], avgLowValue].join(',');
      oscMsg = new _oscJs.default.Message(path, ...(0, _utilities.formatValues)(avgLowValuesSet));
    } else if (avgItems.length === 1) {
      // get: don't format
      oscMsg = new _oscJs.default.Message(path, ...(0, _utilities.formatValues)(values));
    }
  } else if (path.includes('Mult') && !path.includes('threshold')) {
    let multItems = values.split(',');

    if (multItems.length === 2) {
      // set
      multValue = (0, _utilities.formatFloat)(multItems[1]);
      multValuesSet = [multItems[0], multValue].join(',');
      oscMsg = new _oscJs.default.Message(path, ...(0, _utilities.formatValues)(multValuesSet));
    } else if (multItems.length === 1) {
      // get: don't format
      oscMsg = new _oscJs.default.Message(path, ...(0, _utilities.formatValues)(values));
    }
  } else if (path.includes('cb')) {
    oscMsg = new _oscJs.default.Message(path, values);
  } else {
    oscMsg = new _oscJs.default.Message(path, ...(0, _utilities.formatValues)(values));
  }

  if (device._oscDebugSend) console.log('---> osc', oscMsg);
  oscPacked = oscMsg.pack();
  let messageBytesLeft = oscPacked.length,
      sysexEncodeBuffer = [],
      oscEncodeBuffer = oscPacked,
      sysexEncodeBufferIndex = 9,
      oscEncodeBufferIndex = 0,
      payloadSize; // set start sysex

  sysexEncodeBuffer[0] = 0xf0; // set device identity

  Object.keys(indentity).forEach((key, index) => sysexEncodeBuffer[index + 1] = indentity[key]); // set payload

  while (messageBytesLeft > 0) {
    // 4 bytes of 7 bit data
    sysexEncodeBuffer[sysexEncodeBufferIndex++] = oscEncodeBuffer[oscEncodeBufferIndex] & 0x7F;
    sysexEncodeBuffer[sysexEncodeBufferIndex++] = oscEncodeBuffer[oscEncodeBufferIndex + 1] & 0x7F;
    sysexEncodeBuffer[sysexEncodeBufferIndex++] = oscEncodeBuffer[oscEncodeBufferIndex + 2] & 0x7F;
    sysexEncodeBuffer[sysexEncodeBufferIndex++] = oscEncodeBuffer[oscEncodeBufferIndex + 3] & 0x7F; // 5th byte that has the MSbits of the previous 4 bytes
    // This is per the proposed OSC 1.1 spec for tunneling OSC over MIDI Sysex

    sysexEncodeBuffer[sysexEncodeBufferIndex] = (oscEncodeBuffer[oscEncodeBufferIndex] & 0x80) >> 7;
    sysexEncodeBuffer[sysexEncodeBufferIndex] |= (oscEncodeBuffer[oscEncodeBufferIndex + 1] & 0x80) >> 6;
    sysexEncodeBuffer[sysexEncodeBufferIndex] |= (oscEncodeBuffer[oscEncodeBufferIndex + 2] & 0x80) >> 5;
    sysexEncodeBuffer[sysexEncodeBufferIndex] |= (oscEncodeBuffer[oscEncodeBufferIndex + 3] & 0x80) >> 4;
    sysexEncodeBuffer[sysexEncodeBufferIndex] |= 0x70;
    sysexEncodeBufferIndex++;
    oscEncodeBufferIndex += 4;
    messageBytesLeft -= 4;
  }

  payloadSize = sysexEncodeBufferIndex - 9; // set osc message length

  sysexEncodeBuffer[7] = payloadSize >> 7 & 0x7F;
  sysexEncodeBuffer[8] = payloadSize & 0x7F; // set close sysex

  sysexEncodeBuffer[sysexEncodeBuffer.length] = 0xf7; // console.log('%c>>', 'color:orange', 'sysex', sysexEncodeBuffer)

  return sysexEncodeBuffer;
}